<template>
  <v-container>
    <v-row>
      <v-col>
        <h2 class="mb-4">Adminpanel</h2>
        <v-card>
          <v-tabs v-model="tab" background-color="default">
            <v-tab key="vehicles">
              <v-icon left>mdi-fire-truck</v-icon>
              Fahrzeuge & Checklisten
            </v-tab>
            <v-tab key="items">
              <v-icon left>mdi-format-list-bulleted-square</v-icon>
              Item Bibliothek
            </v-tab>
            <v-tab key="users">
              <v-icon left>mdi-account-group</v-icon>
              Benutzer
            </v-tab>
            <v-tab key="settings">
              <v-icon left>mdi-cog</v-icon>
              Einstellungen
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item key="vehicles">
              <VehicleManagement />
            </v-tab-item>
            <v-tab-item key="items">
              <!-- Placeholder for the new component to manage master items -->
              <ItemLibrary />
            </v-tab-item>
            <v-tab-item key="users">
              <UserManagement />
            </v-tab-item>
            <v-tab-item key="settings">
              <AppSettings />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VehicleManagement from './admin/VehicleManagement.vue';
import UserManagement from './admin/UserManagement.vue';
import AppSettings from './admin/AppSettings.vue';
import ItemLibrary from './admin/ItemLibrary.vue'; // Create this new component

export default {
  name: "AdminPanel",
  components: {
    VehicleManagement,
    UserManagement,
    AppSettings,
    ItemLibrary
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>